import { type Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import {
  hasStringPathParamCanActivateGuard,
  sequentialDeactivateGuards,
} from '@pct-ng/core/router';

export const OnboardingStepRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/onboarding-step-list.component').then(
        ({ OnboardingStepListComponent }) => OnboardingStepListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/onboarding-step-details.component').then(
        ({ OnboardingStepDetailsComponent }) => OnboardingStepDetailsComponent,
      ),
    title: 'PAGES.ONBOARDING_STEP.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.ONBOARDING_STEP.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/onboarding-step-details.component').then(
        ({ OnboardingStepDetailsComponent }) => OnboardingStepDetailsComponent,
      ),
    title: 'PAGES.ONBOARDING_STEP.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.ONBOARDING_STEP.SINGULAR'),
      ]),
    ],
  },
];
